import React, { useEffect } from 'react';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { X, CheckCircle, AlertCircle, Loader2, Info } from 'lucide-react';

const ToastProvider = ({ children }) => {
  useEffect(() => {
    // Override default toast styles
    toast.options = {
      duration: 4000,
      position: 'top-right',
      style: {
        background: '#0A0A0A',
        color: '#F7F5F2',
        border: '1px solid rgba(212, 175, 122, 0.2)',
        borderRadius: '12px',
        padding: '16px',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.5)',
      },
      success: {
        iconTheme: {
          primary: '#10B981',
          secondary: '#F7F5F2',
        },
      },
      error: {
        iconTheme: {
          primary: '#EF4444',
          secondary: '#F7F5F2',
        },
      },
    };
  }, []);

  return (
    <>
      {children}
      <Toaster>
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <div className="flex items-center gap-3">
                {icon}
                <span className="text-sm font-medium">{message}</span>
              </div>
            )}
            {t.type !== 'loading' && (
              <button
                onClick={() => toast.dismiss(t.id)}
                className="ml-4 text-[#F7F5F2]/60 hover:text-[#F7F5F2] transition-colors"
              >
                <X size={18} />
              </button>
            )}
          </ToastBar>
        )}
      </Toaster>
    </>
  );
};

export default ToastProvider;

// Custom toast helpers with icons
export const toastSuccess = (message) => {
  return toast.success(message, {
    icon: <CheckCircle size={20} className="text-green-500" />,
  });
};

export const toastError = (message) => {
  return toast.error(message, {
    icon: <AlertCircle size={20} className="text-red-500" />,
    duration: 5000,
  });
};

export const toastInfo = (message) => {
  return toast(message, {
    icon: <Info size={20} className="text-[#D4AF7A]" />,
  });
};

export const toastLoading = (message) => {
  return toast.loading(message, {
    icon: <Loader2 size={20} className="animate-spin text-[#D4AF7A]" />,
  });
};

export const toastPromise = (promise, messages) => {
  return toast.promise(
    promise,
    {
      loading: (
        <div className="flex items-center gap-3">
          <Loader2 size={20} className="animate-spin text-[#D4AF7A]" />
          <span>{messages.loading}</span>
        </div>
      ),
      success: (
        <div className="flex items-center gap-3">
          <CheckCircle size={20} className="text-green-500" />
          <span>{messages.success}</span>
        </div>
      ),
      error: (
        <div className="flex items-center gap-3">
          <AlertCircle size={20} className="text-red-500" />
          <span>{messages.error}</span>
        </div>
      ),
    },
    {
      success: {
        duration: 3000,
        icon: null,
      },
      error: {
        duration: 5000,
        icon: null,
      },
    }
  );
};
